import { types } from "mobx-state-tree";
import { formatMoney } from "modules/common/components/money/Money";

export const showSpending = (spending: number, hours: number) => `${formatMoney(spending)} (${hours}ч)`;

const EmployeeWorkloadSpendingdingItem = types
  .model({
    employeeId: types.string,
    employeeName: types.string,
    plannedHours: types.number,
    plannedSpending: types.number,
    remainingPlannedHours: types.number,
    remainingPlannedSpending: types.number,
    actualHours: types.number,
    actualSpending: types.number,
  })
  .named("EmployeeWorkloadSpendingdingItem");

export const DepartmentWorkloadSpendingItem = types
  .model({
    departmentName: types.string,
    plannedHours: types.number,
    plannedSpending: types.number,
    remainingPlannedHours: types.number,
    remainingPlannedSpending: types.number,
    actualHours: types.number,
    actualSpending: types.number,
    employees: types.array(EmployeeWorkloadSpendingdingItem),
  })
  .named("DepartmentWorkloadSpendingItem");

export const WorkloadSpendingOrder = types
  .model({
    orderId: types.string,
    orderName: types.string,
    totalPlannedHours: types.number,
    totalPlannedSpending: types.number,
    totalRemainingPlannedHours: types.number,
    totalRemainingPlannedSpending: types.number,
    totalActualHours: types.number,
    totalActualSpending: types.number,
    departments: types.array(DepartmentWorkloadSpendingItem),
  })
  .named("WorkloadSpendingOrder");

export type DepartmentWorkloadSpendingItemType = typeof DepartmentWorkloadSpendingItem.Type;
export type DepartmentWorkloadSpendingItemSnapshotType = typeof DepartmentWorkloadSpendingItem.SnapshotType;

export type WorkloadSpendingOrderType = typeof WorkloadSpendingOrder.Type;
export type WorkloadSpendingOrderSnapshotType = typeof WorkloadSpendingOrder.SnapshotType;
